// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"pq-z","imageAndVideoCount":"qq-z","imageAndVideoContainer":"rq-z","viewAllReviews":"sq-z"};